import { render } from "./JourneyModal.vue?vue&type=template&id=96c6b6a2&scoped=true"
import script from "./JourneyModal.vue?vue&type=script&lang=js"
export * from "./JourneyModal.vue?vue&type=script&lang=js"

import "./JourneyModal.vue?vue&type=style&index=0&id=96c6b6a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c6b6a2"]])

export default __exports__